// src/lib/calendarUtils.js

// Converte qualunque input data in "YYYY-MM-DD" (no timezone shift)
export const toDateOnly = (s) => {
  if (!s) return '';
  const str = String(s);
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;
  const d = new Date(str);
  if (isNaN(d)) return '';
  const y = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${mm}-${dd}`;
};

export const addDays = (ymd, n) => {
  const [y,m,d] = ymd.split('-').map(Number);
  const dt = new Date(y, m-1, d);
  dt.setDate(dt.getDate() + n);
  const yy = dt.getFullYear();
  const mm = String(dt.getMonth()+1).padStart(2,'0');
  const dd = String(dt.getDate()).padStart(2,'0');
  return `${yy}-${mm}-${dd}`;
};

export const compareYmd = (a, b) => (a < b ? -1 : a > b ? 1 : 0);

export const daysBetween = (startYmd, endYmd) => {
  let s = startYmd, res = [];
  while (s <= endYmd) {
    res.push(s);
    s = addDays(s, 1);
  }
  return res;
};

export const mergeRanges = (ranges) => {
  const r = ranges
    .filter(r => r.start && r.end && r.start <= r.end)
    .sort((a,b) => compareYmd(a.start, b.start));
  const out = [];
  for (const cur of r) {
    if (out.length === 0) { out.push({...cur}); continue; }
    const last = out[out.length - 1];
    // unisci se sovrapposti o adiacenti
    if (cur.start <= addDays(last.end, 1)) {
      if (cur.end > last.end) last.end = cur.end;
    } else {
      out.push({...cur});
    }
  }
  return out;
};

export const busyDaysFromProduzioni = (produzioni = []) => {
  const confirmedRanges = produzioni
    .filter(p => !p.is_tentative)
    .map(p => ({
      start: toDateOnly(p.data_inizio_contratto || p.data_inizio),
      end:   toDateOnly(p.data_fine_contratto   || p.data_fine),
      label: p.produzione || p.azienda || '',
    }))
    .filter(r => r.start && r.end && r.start <= r.end);
  const tentativeRanges = produzioni
    .filter(p => p.is_tentative)
    .map(p => ({
      start: toDateOnly(p.data_inizio_contratto || p.data_inizio),
      end:   toDateOnly(p.data_fine_contratto   || p.data_fine),
      label: p.produzione || p.azienda || '',
    }))
    .filter(r => r.start && r.end && r.start <= r.end);
  const merged = mergeRanges(confirmedRanges.map(({start,end}) => ({start,end})));
  const mergedTentative = mergeRanges(tentativeRanges.map(({start,end}) => ({start,end})));
  const set = new Set(merged.flatMap(r => daysBetween(r.start, r.end)));
  const tentativeSet = new Set(mergedTentative.flatMap(r => daysBetween(r.start, r.end)));
  for (const d of set) tentativeSet.delete(d);
  const allMerged = mergeRanges([...confirmedRanges, ...tentativeRanges].map(({start,end}) => ({start,end})));
  return { set, merged: allMerged, raw: [...confirmedRanges, ...tentativeRanges], tentativeSet };
};

// Trova il primo "buco" (intervallo libero) dopo una certa data
export const nextGap = (mergedRanges = [], fromYmd) => {
  if (!fromYmd || mergedRanges.length === 0) return null;
  // se fromYmd è prima del primo range
  if (fromYmd < mergedRanges[0].start) {
    return { start: fromYmd, end: addDays(mergedRanges[0].start, -1) };
  }
  // tra range consecutivi
  for (let i=0; i<mergedRanges.length-1; i++) {
    const a = mergedRanges[i];
    const b = mergedRanges[i+1];
    if (fromYmd <= a.end) {
      const candidateStart = addDays(a.end, 1);
      if (candidateStart < b.start) {
        return { start: candidateStart, end: addDays(b.start, -1) };
      }
    } else if (fromYmd > a.end && fromYmd < b.start) {
      return { start: fromYmd, end: addDays(b.start, -1) };
    }
  }
  // dopo l’ultimo range
  const last = mergedRanges[mergedRanges.length - 1];
  if (fromYmd <= last.end) return { start: addDays(last.end, 1), end: null };
  return { start: fromYmd, end: null };
};

// Statistiche anno
export const yearStats = (mergedRanges = [], year) => {
  const start = `${year}-01-01`;
  const end   = `${year}-12-31`;
  let busy = 0;
  for (const r of mergedRanges) {
    const s = r.start > start ? r.start : start;
    const e = r.end   < end   ? r.end   : end;
    if (s <= e) busy += daysBetween(s,e).length;
  }
  const tot = daysBetween(start,end).length;
  return { busy, free: tot - busy, total: tot };
};
